/**
 * Trial switch: the ShapeShift task input in place of the inline TaskComposer on the Tasks page (ToDo.vue).
 * OFF unless a Super Admin turned it on in this browser (localStorage `teamio_shapeshift_tasks` = 'on').
 * Turning it off clears the key. Import-free.
 */

export const SHAPESHIFT_INPUT_KEY = 'teamio_shapeshift_tasks';

export function shouldUseShapeShiftInput({ isSuperAdmin, storage } = {}) {
  if (isSuperAdmin !== true) return false;
  try {
    return !!storage && typeof storage.getItem === 'function' && storage.getItem(SHAPESHIFT_INPUT_KEY) === 'on';
  } catch (e) {
    return false;
  }
}

/** true stores 'on', false clears the key. Returns false when the value is not a boolean or storage refused. */
export function setShapeShiftInput(storage, on) {
  if (on !== true && on !== false) return false;
  try {
    if (!storage) return false;
    if (on) storage.setItem(SHAPESHIFT_INPUT_KEY, 'on');
    else storage.removeItem(SHAPESHIFT_INPUT_KEY);
    return true;
  } catch (e) {
    return false;
  }
}
